module.exports = __webpack_public_path__ + "img/mt.dcb55d42.svg";